"use client";
import classnames from "classnames/bind";
import { useRef } from "react";
import { useDateSegment } from "react-aria";
import type { DateFieldState, DateSegment } from "react-stately";

import styles from "./date-picker.module.scss";

const cx = classnames.bind(styles);
type SegmentProps = {
  segment: DateSegment;
  state: DateFieldState;
};
// Format the year segment with leading zeros
const formatLeadingZeros = (text: string, segmentType: string): string => {
  if (segmentType === "year") {
    return text.padStart(4, "0");
  }
  return text;
};

export function Segment({ segment, state }: SegmentProps) {
  const ref = useRef(null);
  const { segmentProps } = useDateSegment(segment, state, ref);

  return (
    <div {...segmentProps} ref={ref} className={cx("segment")}>
      {segment.isPlaceholder
        ? segment.placeholder
        : formatLeadingZeros(segment.text, segment.type)}
    </div>
  );
}
